import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NotificationPosition } from './models.js';

var PREFIX = "NotificationsCenter";
var classes = {
    positionner: "".concat(PREFIX, "-positionner"),
    notification: "".concat(PREFIX, "-notification")
};
var positionCalc = function (notificationPosition) {
    switch (notificationPosition) {
        case NotificationPosition.Bottom:
            return {
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%)"
            };
        case NotificationPosition.BottomLeft:
            return {
                bottom: 0,
                left: 0
            };
        case NotificationPosition.BottomRight:
            return {
                bottom: 0,
                right: 0
            };
        case NotificationPosition.Top:
            return {
                top: 0,
                left: "50%",
                transform: "translateX(-50%)"
            };
        case NotificationPosition.TopLeft:
            return {
                top: 0,
                left: 0
            };
        case NotificationPosition.TopRight:
            return {
                top: 0,
                right: 0
            };
        case NotificationPosition.Left:
            return {
                left: 0,
                top: "50%",
                transform: "translateY(-50%)"
            };
        case NotificationPosition.Right:
            return {
                right: 0,
                top: "50%",
                transform: "translateY(-50%)"
            };
        default:
            return {};
    }
};
var StyledNotificationsCenterPositionner = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "notificationPosition"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, _c = _a.notificationPosition, notificationPosition = _c === void 0 ? NotificationPosition.TopRight : _c;
    return (__assign(__assign({ position: "fixed", zIndex: theme.zIndex.modal + 1 }, positionCalc(notificationPosition)), (_b = { padding: theme.spacing(1) }, _b["& .".concat(classes.notification)] = {
        margin: theme.spacing(1)
    }, _b)));
});

export { StyledNotificationsCenterPositionner, classes };
//# sourceMappingURL=index.styled.js.map
